import {Component, OnInit} from '@angular/core';
import {VccChartFilter} from '../../../../model/funding-vcc-chart-filter';
import {VccChartModel} from '../../../../model/vcc-chart-model';
import {ChartsVccService} from '../../../../service/charts-vcc.service';
import {Sort} from '@angular/material/sort';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
 
@Component({
    selector: 'financial-balances-vcc-list',
    templateUrl: './financial-balances-vcc-list.component.html',
    standalone: false
})

export class FinancialBalancesVccListComponent implements OnInit{

    displayedColumns: Array<string> = [
        'merchantName',
        'totalBalance',
        'outstandingLiability',
    ];
    public vccChartFilter: VccChartFilter = {} as VccChartFilter;
    items: VccChartModel[] = [];
    sorting: Partial<Sort> = {};
    accAvailableFundsUSD: number[]= [];
    totalFundsUSD: number = 0;
    accAvailableFundsCAD: number[] = [];
    totalFundsCAD: number = 0;
    public isLoading: boolean = true;
    public isError: boolean = false;

    constructor(
        private chartsVccService: ChartsVccService,
        private merchantsService: MerchantsService,
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.isError = false;

        this.vccChartFilter.propertyName = 'releasedDateFrom';
        this.vccChartFilter.orderKey = 'DESC';
        this.chartsVccService.getVccChartFilter().subscribe(() => {
            this.getItems();
        });
    }

    get dateFilterText() {
        return this.chartsVccService.getDateSubTitle();
    }

    handleSortChange(sort: Sort): void { 
        this.sorting = sort;
        if(!this.sorting?.active || !this.sorting?.direction) {
          this.sorting = {};
        }
        this.getItems();
    }

    getItems(){
        this.isLoading = true;
        this.isError = false;
        
        this.chartsVccService.getFundingData()
            .pipe(
                catchError(error => {
                    console.error('Error getting financial balances data:', error);
                    this.isError = true;
                    this.isLoading = false;
                    return of([]);
                })
            )
            .subscribe((data) => {
                if (data && data.length > 0) {
                    this.isError = false;
                    this.items = data.map((item) => {
                        return {
                            merchantGuid: item.merchantGuid,
                            newCashBalance: item.newCashBalance,
                            priorDayCashBalance: item.priorDayCashBalance,
                            totalAti: item.totalAti,
                            totalAta: item.totalAta,
                            outstandingLiability: item.outstandingLiability,
                            outstandingAuthorization: item.outstandingAuthorization,
                        }
                    });
                    
                    this.merchantsService.merchants$.subscribe((merchantData) => {
                        this.items = this.items.map(item => {
                            const merchant = merchantData.find(merchant => merchant.merchantGuid === item.merchantGuid);
                            return {
                                ...item,
                                merchantName: merchant ? merchant.fullName : '',
                                currencyCode: merchant?.currencyName,
                                isIssueTypeAccount: merchant?.isIssueTypeAccount,
                                isAuthorizeTypeAccount: merchant?.isAuthorizeTypeAccount
                            };
                        });

                        this.items.sort((a, b) => (b.totalAta ?? 0) - (a.totalAta ?? 0));

                        this.accAvailableFundsUSD = [];
                        this.accAvailableFundsCAD = [];
                        this.items.map((item) => {
                            if (item.currencyCode === 'USD'){
                                if(item.isAuthorizeTypeAccount){
                                    if (item.totalAta) {
                                        this.accAvailableFundsUSD.push(item.totalAta);
                                    }
                                } else if (item.isIssueTypeAccount){
                                    if (item.totalAti) {
                                        this.accAvailableFundsUSD.push(item.totalAti);
                                    }
                                }
                            }else {
                                if(item.isAuthorizeTypeAccount){
                                    if (item.totalAta) {
                                        this.accAvailableFundsCAD.push(item.totalAta);
                                    }
                                } else if (item.isIssueTypeAccount){
                                    if (item.totalAti) {
                                        this.accAvailableFundsCAD.push(item.totalAti);
                                    }
                                }
                            }
                        });
                        this.totalFundsUSD = this.accAvailableFundsUSD.reduce((acc, item) => { acc += item; return acc; }, 0);
                        this.totalFundsCAD = this.accAvailableFundsCAD.reduce((acc, item) => { acc += item; return acc; }, 0);
                        
                        this.isLoading = false;
                    });
                } else {
                    this.items = [];
                    this.totalFundsUSD = 0;
                    this.totalFundsCAD = 0;
                    this.accAvailableFundsUSD = [];
                    this.accAvailableFundsCAD = [];
                    this.isLoading = false;
                }
            });
    }
    
}